import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { APP_PAGE } from "../../../constants/v2/appConstants";
import commonStyles from "../../v2/style.module.css";
import SVGIcon from "../Images/SVGIcon";
import BottomNavigationBar from "./BottomNavigationBar";
import NavigationBar from "./NavigationBar";
import styles from "./style.module.css";

const SIDEBAR_WIDTH_COLLAPSED = "96px";
const SIDEBAR_WIDTH_EXPANDED = "240px";

const Sidebar = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--sidebar-width",
      isExpanded ? SIDEBAR_WIDTH_EXPANDED : SIDEBAR_WIDTH_COLLAPSED,
    );
  }, [isExpanded]);

  useEffect(() => {
    document.documentElement.style.setProperty("--sidebar-width", SIDEBAR_WIDTH_COLLAPSED);

    return () => {
      document.documentElement.style.removeProperty("--sidebar-width");
    };
  }, []);

  return (
    <div className={styles.container} data-expanded={String(isExpanded)}>
      <div className={styles.logoContainer}>
        <SVGIcon className={styles.icon} src="components/v2/Sidebar/logo.svg" />
        <span className={styles.wordmark}>
          VIDEOOS<span className={styles.wordmarkDot}>.</span>
        </span>
        <button
          className={styles.toggle}
          onClick={() => setIsExpanded((v) => !v)}
          aria-label={isExpanded ? "Collapse sidebar" : "Expand sidebar"}
        >
          <svg
            className={styles.chevron}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="square"
            strokeLinejoin="miter"
          >
            <path d="M9 6l6 6-6 6" />
          </svg>
        </button>
      </div>
      <div className={classNames(styles.navigationContainer, commonStyles.scrollBar)}>
        <NavigationBar page={APP_PAGE.PROFILE_DROPDOWN} isExpanded={isExpanded} />
        <BottomNavigationBar page={APP_PAGE.PROFILE_DROPDOWN} isExpanded={isExpanded} />
      </div>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
